import React from "react";
import SectionHeader from "../../common/sectionTitle";
import { HiMiniChevronRight } from "react-icons/hi2";
import { renderProductInfo } from "../../../common/function/shopping";
import { DeliveryProductsContainer } from "../styled";

const ProductList = ({ subOrders }) => {
  const totalCount = subOrders?.reduce((acc, s) => acc + (s.products?.length || 0), 0) ?? 0;

  return (
    <DeliveryProductsContainer>
      <SectionHeader
        title={`주문 상품 ${totalCount}개`}
        action={{
          label: "주문상세보기",
          icon: HiMiniChevronRight,
          clickEvent: () => console.log("주문상세보기"),
        }}
      />
      {subOrders?.map((subOrder, idx) => (
        <ul key={idx}>
          {subOrder.products.map((product, i) => (
            <li key={i}>
              <img src={imgHandler(product.media)} alt={product.productName} />
              {renderProductInfo(product)}
            </li>
          ))}
        </ul>
      ))}
    </DeliveryProductsContainer>
  );
};

export default ProductList;
